<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="140px"
      size="small"
    >
      <div class="form-section-title">
        <span>
          {{ $l('section_goods_code_price') || '商品编码与价格' }}
        </span>
      </div>
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_hscode') || '报关HSCODE'"
            prop="hscode"
          >
            <el-input
              v-model.trim="formData.hscode"
              :placeholder="$l('form_placeholder_hscode') || '请输入报关HSCODE'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_customsPriceUsd') || '报关单价(USD)'"
            prop="customsPrice"
          >
            <el-input-number
              v-model="formData.customsPrice"
              :placeholder="
                $l('form_placeholder_customsPrice') || '请输入报关单价(USD)'
              "
              controls-position="right"
              :min="0"
              :step="0.01"
              :precision="4"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="form-section-title">
        <span>
          {{ $l('section_declaration_name') || '申报品名' }}
        </span>
      </div>
      <el-row :gutter="12">
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_hscodeName') || '报关中文品名'"
            prop="hscodeName"
          >
            <el-input
              v-model.trim="formData.hscodeName"
              :placeholder="
                $l('form_placeholder_hscodeName') || '请输入报关中文品名'
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_hscodeNameEn') || '报关英文品名'"
            prop="hscodeNameEn"
          >
            <el-input
              v-model.trim="formData.hscodeNameEn"
              :placeholder="
                $l('form_placeholder_hscodeNameEn') || '请输入报关英文品名'
              "
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="form-section-title">
        <span>
          {{ $l('section_origin_elements') || '产地与申报要素' }}
        </span>
      </div>
      <el-row :gutter="12">
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_originalPlace') || '境内货源地'"
            prop="originalPlace"
          >
            <el-input
              v-model.trim="formData.originalPlace"
              :placeholder="
                $l('form_placeholder_originalPlace') || '请输入境内货源地'
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_declarationElements') || '申报要素'"
          >
            <el-input
              v-model.trim="formData.declarationElements"
              :placeholder="
                $l('form_placeholder_declareElement') || '请输入申报要素'
              "
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  props: {
    shipmentGoodsCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        hscode: [
          {
            required: true,
            message: this.$l('form_placeholder_hscode') || '请输入报关HSCODE',
            trigger: 'blur',
          },
        ],
        customsPrice: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customsPrice') || '请输入报关单价(USD)',
            trigger: 'blur',
          },
        ],
        hscodeName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_hscodeName') || '请输入报关中文品名',
            trigger: 'blur',
          },
        ],
        hscodeNameEn: [
          {
            required: true,
            message:
              this.$l('form_placeholder_hscodeNameEn') || '请输入报关英文品名',
            trigger: 'blur',
          },
        ],
        originalPlace: [
          {
            required: true,
            message:
              this.$l('form_placeholder_originalPlace') || '请输入境内货源地',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.shipmentGoodsCode) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentGoodsDetailApi({
          shipmentGoodsCode: this.shipmentGoodsCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      this.formData = res.body || {}
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentGoodsSaveCustomsApi({ ...this.formData })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      const error = status !== 200

      this.$message({
        showClose: true,
        message: msg,
        type: error ? 'error' : 'success',
      })
      if (error) return

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.form-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-top: 12px;
  margin-bottom: 8px;
}

.form-section-title:first-child {
  margin-top: 0;
}
</style>
